import { Config } from '../config';
import axios from 'axios';
class DataContextService {
    get(url, parameters) {
        url = Config.apiUrl + url;
        
        let options = {
            params: parameters
        }

        return axios.get(url, options).then((response) => response);
    }
}

export default new DataContextService();
export { DataContextService };